import React, { useEffect, useState } from "react";
import {
  TextField,
  InputAdornment,
  Typography,
  Button,
  FormHelperText,
  FormGroup,
  FormControlLabel,
  Checkbox,
  CircularProgress,
} from "@mui/material";
import Slide, { SlideProps } from "@mui/material/Slide";
import { LoadingButton } from "@mui/lab";
import { useNavigate, useLocation } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import {
  sendMobileNoAPICall,
  locationCheckAPICall,
  AdminLoginToClientAccountAPICall,
  reSendMobileOTPAPICall,
  validateMobileOTPAPICall,
  SaveIpAddressAPICall,
} from "../shared/APICalls";
import {
  IAdminLogin,
  IMobile,
  IMobileOtpValidation,
  IReSendMobileOTP,
  ISaveIPaddress,
} from "../shared/dtos";
import routesData from "../shared/routes.json";
import SignupStyles from "../pages/Styles/SignUp.module.scss";
import SnackBar from "../Components/SnackBars/SnackBar";
import firstockLogo from "../Components/assets/Images/Firstocklogo.svg";
import Checkboxempty from "../Components/assets/Images/Checkboxempty.svg";
import Checkboxdone from "../Components/assets/Images/Checkbox_blue.svg";
import axios from "axios";
import TagManager from "react-gtm-module";
import otpIcon from "../Components/assets/Images/otpIcon.svg";

import { eventNames } from "process";
import { TransitionProps } from "@mui/material/transitions";
import SucessSnackBar from "../Components/SnackBars/SucesssnackBar";

const dots = ["1", "2", "3", "4", "5", "6"];

export default function SignupPage() {
  const navigate = useNavigate();
  const [userDeniedLocation, setuserDeniedLocation] = useState(false);
  const [isSafari, setisSafari] = useState(false);
  const [isFireFox, setisFireFox] = useState(false);
  const [loading, setloading] = useState(false);
  const [getloading, setGetloading] = useState(false);
  const [showContent, setshowContent] = useState(true);
  const [message, setMessage] = useState("");
  const [loadingcontent, setloadingcontent] = useState(true);
  const [sebiCheck, setsebiCheck] = useState(false);
  const [IPAddress, setIPAddress] = useState("");
  const [latitude, setlatitude] = useState("");
  const [longitude, setlongitude] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const navigationData = routesData;
  const [countdown, setCountdown] = useState<any>(30);
  const urlParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlParams.entries());
  const source = Object.keys(params)[0];
  const id = (params.c && params.c) || (params.p && params.p);
  const userAgent = navigator.userAgent;
  const [timerId, setTimerId] = useState<any>(null);
  const [successMessage, setSuccessMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [transition, setTransition] = React.useState<
    React.ComponentType<TransitionProps> | undefined
  >(undefined);
  const client_id = params.client_id;
  const user_id = params.user_id;

  if (source) {
    sessionStorage.setItem("source", source);
    sessionStorage.setItem("id", id);
  }

  useEffect(() => {
    window.scrollTo(0, 0);

    // const fetchIPAddress = async () => {
    //   try {
    //     const response = await axios.get(
    //       "https://ipapi.co/json/?key=jmJoC4fsM8a1wzvqBWZsEBfRiXtQqsTtz4XdAXaDb27gq2s9QJ"
    //     );
    //     setIPAddress(response.data?.ip);
    //   } catch (err: any) {}
    // };
    // fetchIPAddress();
  }, []);

  useEffect(() => {
    locationCheckAPICall()
      .then((response: any) => {
        if (response.data.data) {
          setlatitude(response.data.data.latitude);
          setlongitude(response.data.data.longitude);
          sessionStorage.setItem("latitude", response.data.data.latitude);
          sessionStorage.setItem("longitude", response.data.data.longitude);
        }
        if (response.data.data.status === false) {
          setshowContent(false);
        }
      })
      .catch((error: any) => {
        // console.log("error", error);
        setshowContent(false);
      });
  }, []);

  useEffect(() => {
    if (client_id && client_id) {
      let obj: IAdminLogin = {
        client_id: client_id,
        admin_id: user_id,
      };

      AdminLoginToClientAccountAPICall(obj)
        .then((response: any) => {
          const responseData = response.data;
          sessionStorage.setItem(
            "access-token",
            responseData.data.access_token,
          );
          if (
            responseData.data.next_stage &&
            navigationData.hasOwnProperty(responseData.data.next_stage)
          ) {
            navigate(navigationData[responseData.data.next_stage]);
          }
        })
        .catch((error: any) => {
          setMessage(error.response.data.message);
          setTimeout(() => {
            setMessage("");
          }, 5000);
        });
    }
  }, [client_id, user_id]);

  useEffect(() => {
    // setIsButtonDisabled(true);
    // setCountdown(30);
    // if (timerId === null) {
    //   let interval = setInterval(() => {
    //     setCountdown((prevCountdown) => prevCountdown - 1);
    //   }, 1000);
    //   setTimerId(interval);
    // }
  }, []);
  useEffect(() => {
    if (countdown <= 0 && timerId !== null) {
      setIsButtonDisabled(false);

      clearInterval(timerId);
      setTimerId(null);
    }
  }, [countdown]);

  function sendMobileNumber(data: any) {
    TagManager.dataLayer({
      dataLayer: {
        event: "formSubmitMobile",
        phone: data,
      },
    });

    setGetloading(true);
    let obj: IMobile = {
      mobile: data,
      ip_address: IPAddress?.trim(),
      device_type: userAgent?.toString(),
    };
    sendMobileNoAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        setMobileNumber(data);
        sessionStorage.setItem("mobile", data);
        setSuccessMessage("Successfully sent the OTP to your Mobile.");
        setTimeout(() => {
          setSuccessMessage("");
        }, 5000);
        setOtpSent(true);
        setGetloading(false);
        setIsButtonDisabled(true);
        setCountdown(30);
        if (timerId === null) {
          let interval = setInterval(() => {
            setCountdown((prevCountdown) => prevCountdown - 1);
          }, 1000);
          setTimerId(interval);
        }
        // if (
        //   responseData.data.next_stage &&
        //   navigationData.hasOwnProperty(responseData.data.next_stage)
        // ) {
        //   navigate(navigationData[responseData.data.next_stage]);
        // }
      })
      .catch((error: any) => {
        setGetloading(false);
        setOtpSent(false);
        setMessage(
          error.message.includes("Network")
            ? "Error occured, Please try again"
            : error.response.data.message,
        );
        setTimeout(() => {
          setMessage("");
        }, 5000);
      });
  }

  function validatePhoneNumber(value: any) {
    let error: any;
    if (!value) {
      error = "Mobile Number Required";
    } else if (!/^[0-9]{10}$/.test(value)) {
      error = "Must be a valid 10 digit mobile number";
    }
    return error;
  }

  function validateOTP(value: any) {
    let error: any;
    if (!value) {
      error = "OTP Required";
    } else if (!/^[0-9]{6}$/.test(value)) {
      error = "Must be a valid 6 digit OTP";
    }
    return error;
  }

  useEffect(() => {
    setTimeout(() => {
      setloadingcontent(false);
    }, 1000);
    const listener = (event) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        // console.log("Enter key was pressed. Run your function.");
        const onFormSubmit = (values) => {
          sendMobileNumber(values.phoneNumber);
        };

        event.preventDefault();
        // callMyFunction();
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, []);

  const handleResendOTP = (values: any) => {
    setloading(true);
    reSendMobileOTP(values);
  };

  function reSendMobileOTP(values: any) {
    let obj: IReSendMobileOTP = {
      mobile: values?.phoneNumber,
    };
    reSendMobileOTPAPICall(obj)
      .then((response: any) => {
        const responseData = response.data.data;
        setloading(false);
        setSuccessMessage("Successfully sent the OTP to your Mobile.");
        setTimeout(() => {
          setSuccessMessage("");
        }, 5000);
        setIsButtonDisabled(true);
        setCountdown(30);
      })
      .catch((error: any) => {
        if (error.response.status === 404) {
          setMessage("Failed to Continue, Please try Again");
          setTimeout(() => {
            setMessage("");
          }, 5000);
        }
        setMessage(
          error.message.includes("Network")
            ? "Error occured, Please try again"
            : error.response.data.message,
        );
        setTimeout(() => {
          setMessage("");
        }, 5000);
      });

    if (timerId === null) {
      let interval = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
      setTimerId(interval);
    }
  }

  function validateMobileOTP(data: any) {
    setloading(true);

    TagManager.dataLayer({
      dataLayer: {
        event: "formSubmitMobileotp",
        phone: data,
      },
    });

    const source = sessionStorage.getItem("source");
    const id = sessionStorage.getItem("id");

    let obj: IMobileOtpValidation = {
      mobile: data?.phoneNumber,
      mobile_otp: data?.mobileotp,
      ref_source: source ? source : "web",
      ref_code: id ? id : "",
    };
    setloading(true);
    setTimeout(() => {
      validateMobileOTPAPICall(obj)
        .then((response: any) => {
          setloading(false);
          const responseData = response.data;
          // console.log("response", responseData);
          if (responseData.data.next_stage === "application_approved") {
            if (responseData.data.access_token) {
              // console.log("token", responseData.data.access_token);
              sessionStorage.setItem(
                "access-token",
                responseData.data.access_token,
              );
            }

            if (responseData.data.client_code) {
              sessionStorage.setItem(
                "client_id",
                responseData.data.client_code,
              );
            }
            navigate(navigationData[responseData.data.next_stage]);
          } else {
            if (responseData.data.access_token) {
              // console.log("token", responseData.data.access_token);
              sessionStorage.setItem(
                "access-token",
                responseData.data.access_token,
              );
            }

            if (responseData.data.client_code) {
              sessionStorage.setItem(
                "client_id",
                responseData.data.client_code,
              );
            }
            sessionStorage.removeItem("source");
            sessionStorage.removeItem("id");

            let objIPAddress: ISaveIPaddress = {
              latitude: latitude?.toString(),
              longitude: longitude?.toString(),
            };
            SaveIpAddressAPICall(objIPAddress)
              .then((response: any) => {
                // console.log("responseIPSave", response.data);
                if (
                  responseData.data.next_stage &&
                  navigationData.hasOwnProperty(responseData.data.next_stage)
                ) {
                  navigate(navigationData[responseData.data.next_stage]);
                }
              })
              .catch((error: any) => {
                if (error.response.data.message) {
                  setMessage(
                    error.message.includes("Network")
                      ? "Error occured, Please try again"
                      : error.response.data.message,
                  );
                } else {
                  setMessage("Error occured, Please try again");
                }
                setloading(false);
                setTimeout(() => {
                  setMessage("");
                }, 5000);
              });
          }
        })
        .catch((error: any) => {
          setloading(false);
          if (error.response.status === 404) {
            setMessage("Failed to Continue, Please try Again");
            setTimeout(() => {
              setMessage("");
            }, 5000);
          }
          setMessage(
            error.message.includes("Network")
              ? "Error occured, Please try again"
              : error.response.data.message,
          );
          setTimeout(() => {
            setMessage("");
          }, 5000);
        });
    }, 500);
  }

  const handleChangeField = (
    name: any,
    value: any,
    setFieldValue: any,
    values: any,
  ) => {
    setFieldValue(name, value);
    // console.log(value);
    // if (value.length === 6) {
    //   validateMobileOTP(values);
    // }
  };

  return (
    <>
      <SnackBar message={message} />
      <SucessSnackBar message={successMessage} />
      <div className={SignupStyles.wrapper}>
        <div className={SignupStyles.RightContainer}>
          <div className={SignupStyles.topLogoSection}>
            <img src={firstockLogo} className={SignupStyles.topLogo} />
          </div>

          <div className={SignupStyles.contentSection}>
            <div className={SignupStyles.headerSection}>
              <p className={SignupStyles.signup}>Join the Growth Journey</p>
              <p className={SignupStyles.subText}>
                Stocks. Mutual Funds. IPO. F&O
              </p>
            </div>

            {showContent ? (
              <Formik
                initialValues={{
                  phoneNumber: "",
                  mobileotp: "",
                }}
                onSubmit={(values) => {
                  if (latitude === "") {
                    setMessage("Location details not found");
                    setTimeout(() => {
                      setMessage("");
                    }, 5000);
                  } else {
                    // sendMobileNumber(values.phoneNumber);
                    validateMobileOTP(values);
                  }
                }}
              >
                {({
                  errors,
                  touched,
                  handleChange,
                  values,
                  handleSubmit,
                  setFieldValue,
                }) => (
                  <Form
                    // onKeyDown={(event) => {
                    //   event.code === "Enter" && handleSubmit();
                    // }}
                    style={{ width: "98%" }}
                  >
                    {!userDeniedLocation ? (
                      <div style={{ width: "100%" }}>
                        <Field
                          name="phoneNumber"
                          validate={validatePhoneNumber}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              autoComplete="off"
                              label=""
                              type="numeric"
                              sx={{
                                fieldset: {
                                  borderColor: "#E5E7EB",
                                  borderRadius: "100px",
                                  height: "60px",
                                },
                              }}
                              placeholder="Enter Mobile Number"
                              className={SignupStyles.textfield}
                              variant="outlined"
                              value={values.phoneNumber}
                              onChange={handleChange}
                              inputProps={{
                                sx: {
                                  "&::placeholder": {
                                    paddingLeft: "-40px",
                                    color: "#111827",
                                    fontWeight: 400,
                                    fontStye: "normal",
                                  },

                                  paddingLeft: "-40px",
                                },
                                maxLength: 10,
                                inputMode: "numeric",
                                pattern: "[0-9]*",
                              }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment
                                    position="start"
                                    style={{
                                      borderRight: "1px solid #E5E7EB",
                                      height: "22px",
                                      paddingRight: "5px",
                                    }}
                                  >
                                    +91
                                  </InputAdornment>
                                ),
                                endAdornment: (
                                  <InputAdornment position="end">
                                    {values.phoneNumber?.length > 9 && (
                                      <>
                                        {mobileNumber !== values.phoneNumber ? (
                                          <Button
                                            disableElevation
                                            disableFocusRipple
                                            disableTouchRipple
                                            size="small"
                                            sx={{
                                              width: "73px",
                                              height: "max-content",
                                              background: "#3263E5",
                                              color: "#fff",
                                              fontSize: "12px",
                                              fontWeight: 400,
                                              padding: "4px",
                                              "&:hover": {
                                                background: "#3263E5",
                                              },
                                            }}
                                            onClick={() => {
                                              if (!getloading) {
                                                sendMobileNumber(
                                                  values.phoneNumber,
                                                );
                                              }
                                            }}
                                          >
                                            {getloading ? (
                                              <CircularProgress
                                                style={{
                                                  color: "inherit",
                                                  width: "20px",
                                                  height: "20px",
                                                }}
                                              />
                                            ) : (
                                              "Get OTP"
                                            )}
                                          </Button>
                                        ) : (
                                          <Button
                                            disableElevation
                                            disableFocusRipple
                                            disableTouchRipple
                                            size="small"
                                            disabled={isButtonDisabled}
                                            sx={{
                                              width: "73px",
                                              height: "max-content",
                                              background: "#3263E5",
                                              color: "#fff",
                                              fontSize: "12px",
                                              fontWeight: 400,
                                              padding: "4px",
                                              "&:hover": {
                                                background: "#3263E5",
                                              },
                                              "&.Mui-disabled": {
                                                background:
                                                  "#3263E5 !important",
                                                color: "#fff",
                                                opacity: 0.5,
                                              },
                                            }}
                                            onClick={() => {
                                              setFieldValue("mobileotp", "");
                                              handleResendOTP(values);
                                            }}
                                          >
                                            Resend
                                          </Button>
                                        )}
                                      </>
                                    )}
                                  </InputAdornment>
                                ),
                              }}
                              onKeyPress={(event) => {
                                const keyCode = event.keyCode || event.which;
                                const keyValue = String.fromCharCode(keyCode);
                                const isValidKey = /^\d+$/.test(keyValue);

                                if (!isValidKey) {
                                  event.preventDefault();
                                }
                              }}
                            />
                          )}
                        />

                        <FormHelperText
                          style={{
                            color: "#d32f2f",
                            height: "10px",
                            marginTop: "3px",
                            textAlign: "center",
                          }}
                        >
                          {errors.phoneNumber &&
                            touched.phoneNumber &&
                            errors.phoneNumber}
                        </FormHelperText>

                        <p className={SignupStyles.smallText}>
                          You will receive an OTP on your number
                        </p>

                        {otpSent && (
                          <>
                            <div
                              style={{ width: "100%", position: "relative" }}
                            >
                              <Field
                                name="mobileotp"
                                validate={validateOTP}
                                render={({ field }) => (
                                  <TextField
                                    autoComplete="off"
                                    autoFocus
                                    {...field}
                                    sx={{
                                      fieldset: {
                                        borderColor: "#E5E7EB",
                                        borderRadius: "100px",
                                        height: "60px",
                                      },
                                      background: "transparent",
                                    }}
                                    label=""
                                    InputLabelProps={{ shrink: false }}
                                    placeholder=""
                                    // placeholder="••••••"
                                    type="numeric"
                                    className={SignupStyles.textfield}
                                    variant="outlined"
                                    value={values.mobileotp}
                                    onChange={(event) => {
                                      const updatedValue = event.target.value;
                                      handleChangeField(
                                        "mobileotp",
                                        updatedValue,
                                        setFieldValue,
                                        values,
                                      );
                                    }}
                                    inputProps={{
                                      sx: {
                                        "&::placeholder": {
                                          paddingLeft: "-20px",

                                          fill: "var(--Black-Black-500, #6B7280)",
                                          fontWeight: 600,
                                          fontSize: "2.19rem",
                                          background: "transparent",
                                          height: "29px",
                                          letterSpacing: {
                                            xs: "20px",
                                            sm: "17px",
                                          },
                                        },
                                        // borderLeft: "1px solid #E5E7EB",
                                        // height: "30px",
                                        paddingLeft: "-20px",

                                        fontWeight: 500,
                                        letterSpacing: {
                                          xs: "25.5px",
                                          sm: "22.5px",
                                        },

                                        background: "transparent",
                                      },
                                      maxLength: 6,
                                      inputMode: "numeric",
                                      pattern: "[0-9]*",
                                    }}
                                    InputProps={{
                                      startAdornment: (
                                        <InputAdornment
                                          position="start"
                                          style={{
                                            // borderRight: "1px solid #E5E7EB",
                                            // height: "22px",
                                            paddingRight: "10px",
                                            paddingLeft: "5px",
                                          }}
                                        >
                                          <img src={otpIcon} />
                                        </InputAdornment>
                                      ),
                                    }}
                                    onKeyPress={(event) => {
                                      const keyCode =
                                        event.keyCode || event.which;
                                      const keyValue =
                                        String.fromCharCode(keyCode);
                                      const isValidKey = /^\d+$/.test(keyValue);

                                      if (!isValidKey) {
                                        event.preventDefault();
                                      }
                                    }}
                                  />
                                )}
                              />
                              <FormHelperText
                                style={{
                                  color: "#d32f2f",
                                  height: "10px",
                                  marginTop: "3px",
                                  textAlign: "center",
                                }}
                              >
                                {touched.mobileotp &&
                                  errors.mobileotp?.toString()}
                              </FormHelperText>

                              {values.mobileotp?.length === 0 && (
                                <div
                                  className={SignupStyles.placeholderstyling}
                                >
                                  {dots.map((a: any, index: any) => (
                                    <div
                                      className={SignupStyles.dot}
                                      style={{
                                        opacity:
                                          values.mobileotp.length + 1 >=
                                          index + 1
                                            ? "0.4"
                                            : "1",
                                      }}
                                    ></div>
                                  ))}
                                </div>
                              )}
                              {values.mobileotp.length > 0 && (
                                <div
                                  className={SignupStyles.placeholderstyling}
                                >
                                  {dots.map((a: any, index: any) => (
                                    <div
                                      className={SignupStyles.dot}
                                      style={{
                                        opacity:
                                          values.mobileotp.length + 1 >=
                                          index + 1
                                            ? "0.4"
                                            : "1",
                                        visibility:
                                          values.mobileotp.length >= index + 1
                                            ? "hidden"
                                            : "visible",
                                      }}
                                    ></div>
                                  ))}
                                </div>
                              )}
                            </div>

                            {isButtonDisabled ? (
                              <div className={SignupStyles.resendSection}>
                                <p className={SignupStyles.clickhere}>
                                  Resend OTP in{" "}
                                  <span style={{ color: "#3263E5" }}>
                                    {countdown}
                                  </span>{" "}
                                  Seconds
                                </p>
                              </div>
                            ) : (
                              <div className={SignupStyles.resendSection}></div>
                            )}
                          </>
                        )}
                        <FormGroup
                          sx={{ marginLeft: "10px", marginTop: "30px" }}
                        >
                          <FormControlLabel
                            sx={{ alignItems: "start" }}
                            control={
                              <Checkbox
                                name="fatcacondition1"
                                sx={{
                                  padding: "0px",
                                  width: "20px",
                                  height: "20px",
                                  marginTop: "6px",
                                }}
                                checked={sebiCheck}
                                icon={<img src={Checkboxempty} />}
                                checkedIcon={<img src={Checkboxdone} />}
                              />
                            }
                            onChange={(event: any) => {
                              const { checked } = event.target;
                              setsebiCheck(checked);
                            }}
                            label={
                              <span
                                className={SignupStyles.smallTextCheckBox}
                                style={{ padding: 0 }}
                              >
                                I express my consent in opening online KYC
                                process
                              </span>
                            }
                          />
                        </FormGroup>

                        <div className={SignupStyles.buttonSection}>
                          {values.phoneNumber.length === 10 &&
                          sebiCheck &&
                          values.mobileotp.length === 6 ? (
                            <LoadingButton
                              variant="contained"
                              type="submit"
                              loading={loading}
                              id="signupContinueButton"
                              className={SignupStyles.button}
                              onClick={() => {
                                handleSubmit();
                              }}
                            >
                              Continue
                            </LoadingButton>
                          ) : (
                            <Button
                              variant="contained"
                              disabled
                              className={SignupStyles.button}
                            >
                              Continue
                            </Button>
                          )}
                        </div>
                      </div>
                    ) : (
                      <>
                        <div>
                          <Typography>
                            Location Access is blocked, please grant the
                            Loaction access in browser settings to proceed
                            further{" "}
                          </Typography>
                        </div>
                        {isFireFox && (
                          <div>
                            <Button
                              variant="outlined"
                              onClick={() => {
                                window.location.reload();
                              }}
                              id="signupReloadButton"
                            >
                              Reload
                            </Button>
                          </div>
                        )}
                        {isSafari ? (
                          <div>
                            <Typography>
                              Please Press Reload Button after granting camera
                              access
                            </Typography>
                            <Button
                              variant="outlined"
                              onClick={() => {
                                window.location.reload();
                              }}
                              id="signupSafariReloadButton"
                            >
                              Reload
                            </Button>
                          </div>
                        ) : (
                          ""
                        )}
                      </>
                    )}
                  </Form>
                )}
              </Formik>
            ) : (
              <div
                // marginTop={'150px'}
                style={{
                  minHeight: "200px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                Access Allowed Only in India{" "}
              </div>
            )}

            <div className={SignupStyles.bottomTextSection}>
              <p className={SignupStyles.bottomTextDesc}>
                By proceeding, I agree to Firstock’s{" "}
                <span style={{ fontWeight: 400, color: "#3263E5" }}>
                  {" "}
                  <a
                    href="https://firstock.in/termsandconditions"
                    target="_blank"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    Terms and Conditions
                  </a>
                </span>{" "}
                and{" "}
                <span style={{ fontWeight: 400, color: "#3263E5" }}>
                  {" "}
                  <a
                    href="https://firstock.in/privacypolicy"
                    target="_blank"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    Privacy Policy
                  </a>
                </span>{" "}
                and{" "}
                <span style={{ fontWeight: 400, color: "#3263E5" }}>
                  {" "}
                  <a
                    href="https://firstock.in/pricing"
                    target="_blank"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    Pricing Policy
                  </a>
                </span>
              </p>
            </div>
          </div>
        </div>
        <div className={SignupStyles.bottomTextSectionMobile}>
          <p className={SignupStyles.bottomTextDesc}>
            By proceeding, I agree to Firstock’s{" "}
            <span style={{ fontWeight: 400, color: "#3263E5" }}>
              {" "}
              <a
                href="https://firstock.in/termsandconditions"
                target="_blank"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Terms and Conditions
              </a>
            </span>{" "}
            and{" "}
            <span style={{ fontWeight: 400, color: "#3263E5" }}>
              {" "}
              <a
                href="https://firstock.in/privacypolicy"
                target="_blank"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Privacy Policy
              </a>
            </span>{" "}
            and{" "}
            <span style={{ fontWeight: 400, color: "#3263E5" }}>
              {" "}
              <a
                href="https://firstock.in/pricing"
                target="_blank"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Pricing Policy
              </a>
            </span>
          </p>
        </div>
        <div className={SignupStyles.login}>
          Already have an account?{" "}
          <span
            onClick={() => {
              window.open("https://app.firstock.in/login", "_blank");
            }}
            style={{
              color: "#3263E5",
              cursor: "pointer",
            }}
          >
            Login
          </span>
        </div>
      </div>
    </>
  );
}
